// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2iyOM","content":"RecentSearches_content__2-qcv"};